// @flow

import React, { PureComponent } from 'react';

import ZapOwner from 'app/dashboard/components/ZapOwner';

type ZapOwnerStatefulProps = {
  avatarUrl: string,
  name: string,
};

type ZapOwnerStatefulState = {
  isShowingPopover: boolean,
};

class ZapOwnerStateful extends PureComponent<
  ZapOwnerStatefulProps,
  ZapOwnerStatefulState
> {
  state = {
    isShowingPopover: false,
  };

  onHover = (isHovering: boolean) => {
    this.setState({ isShowingPopover: isHovering });
  };

  render() {
    return <ZapOwner {...this.props} {...this.state} onHover={this.onHover} />;
  }
}

export default ZapOwnerStateful;
